import { AxiosError } from 'axios';

const isAxiosError = (error: any): error is AxiosError => error?.isAxiosError === true;

export default isAxiosError;
